import { render } from "./ProfessionalExperience.vue?vue&type=template&id=00c06dd9&scoped=true"
import script from "./ProfessionalExperience.vue?vue&type=script&lang=js"
export * from "./ProfessionalExperience.vue?vue&type=script&lang=js"

import "./ProfessionalExperience.vue?vue&type=style&index=0&id=00c06dd9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c06dd9"]])

export default __exports__